import { motion } from "framer-motion";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "home", label: "Index" },
  { id: "manifesto", label: "Manifesto" },
  { id: "work", label: "Work" },
  { id: "portrait", label: "Portrait" },
  { id: "contact", label: "Contact" },
];

function scrollTo(id) {
  const el = document.getElementById(id);
  const lenis = window.__lenis;
  if (lenis && el) lenis.scrollTo(el, { offset: -20 });
  else if (el) el.scrollIntoView({ behavior: "smooth" });
}

export const Nav = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -14, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.95, ease: [0.16, 1, 0.3, 1], delay: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 bg-bg/60 backdrop-blur-xl border-b border-white/[0.05]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("home")}
          className="group inline-flex items-center gap-3 text-ink hover-fade hover:text-sun"
        >
          <span className="block w-2 h-2 rounded-full bg-sun animate-pulse" />
          <span className="font-mono text-[11px] tracking-widest2 uppercase">JTW / MMXXVI</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n, i) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}-link`}
              onClick={() => scrollTo(n.id)}
              className="link-sweep font-mono text-[11px] tracking-widest2 uppercase text-muted hover:text-ink hover-fade"
            >
              <span className="text-sun mr-2">{String(i + 1).padStart(2, "0")}</span>
              {n.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-ink"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/[0.05] bg-bg/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n, i) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}-link`}
                onClick={() => {
                  scrollTo(n.id);
                  setOpen(false);
                }}
                className="text-left font-mono text-sm tracking-widest2 uppercase text-muted hover:text-sun"
              >
                <span className="text-sun mr-2">{String(i + 1).padStart(2, "0")}</span>
                {n.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </motion.header>
  );
};
